import PropTypes from 'prop-types'

// Internal Components
import LazyImage from '../LazyImage/LazyImage'
import Caption from '../Caption/Caption'

const FigureLandscape = ({ figureImage, figureCaption, figureCaptionHtml }) => {
  const captionHtml = figureCaptionHtml?.html ?? figureCaption
  return (
    <div className="FigureLandscape-wrap">
      <div className="FigureLandscape-image">
        <LazyImage {...figureImage[0]} />
      </div>
      {captionHtml && <Caption iconId="icon-image" html={captionHtml} modifiers={['Caption--figureLandscape']} />}
    </div>
  )
}

export default FigureLandscape

FigureLandscape.propTypes = {
  figureImage: PropTypes.array,
  figureCaption: PropTypes.string,
  figureCaptionHtml: PropTypes.object
}
